import React from "react";

import StytchLogin from "../components/Login/StytchLogin";

function StytchLoginPage(): JSX.Element {
  return <StytchLogin />;
}

export default StytchLoginPage;
